// extracted by mini-css-extract-plugin
export var list = "navLinks-module--list--PQrxP";
export var space = "navLinks-module--space--1RvVc";
export var hello = "navLinks-module--hello--1ysUY";
export var footer = "navLinks-module--footer--1BjIX";